<template>
    <div class="search-head">
        
        <div class="input-bar">
        <slot class=""></slot>

            <div class="inner">

            <div class="input">
                <el-input
                    v-model="model"
                    :placeholder="placeholder"
                ></el-input>
            </div>
            <div class="search">
                <i
                    class="el-icon-search"
                    @click="searchHandler"
                ></i>
            </div>
            <div
                class="reset"
                @click="resetHandler"
            >
                重置
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import MODEL_MIXIN from '@mixins/model';

export default {
    mixins: [MODEL_MIXIN],
    props:{
        placeholder:{
            type: String,
            default: '请输入采购信息',
        }
    },
    data() {
        return {};
    },
    methods: {
        searchHandler() {
            this.$emit('search');
        },
        resetHandler() {
            this.model = '';
            this.$emit('reset');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.search-head {
    min-height: 152px;
    background: url(/images/bg-search.png);
    background-size: cover;
    background-position: center center;
    position: relative;

    .input-bar {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 967px;
        min-height: 54px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .inner{
            display: flex;
            width: 100%;
            height: 54px;
        }

        .input {
            flex: 1;

            ::v-deep {
                .el-input {
                    height: 100%;

                    .el-input__inner {
                        height: 100%;
                        border-radius: 0;
                        border: none;
                    }
                }
            }
        }

        .search {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 54px;
            font-size: 30px;
            background: $primaryColor;
            color: white;
            cursor: pointer;

            &:hover {
                background: $primaryColor8;
            }
        }

        .reset {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 54px;
            font-size: 20px;
            color: $primaryColor;
            border: 1px solid $primaryColor;
            background: white;
            cursor: pointer;

            &:hover {
                background: $primaryColor1;
            }
        }
    }
}
</style>